import EventEmitter from "events";
import eventTypes from "./event-types.const";

class HistoryPages extends EventEmitter {
  private static INSTANCE: HistoryPages;
  private history: number[] = [];

  public static getInstance(): HistoryPages {
    if (!HistoryPages.INSTANCE) {
      HistoryPages.INSTANCE = new HistoryPages();
    }

    return HistoryPages.INSTANCE;
  }

  constructor() {
    super();

    this.on(eventTypes.SAVE, (pageSufix: number) => {
      if (pageSufix !== this.history.at(-1)) {
        this.history.push(pageSufix);
      }
    });

    this.on(eventTypes.RESET, () => {
      this.history = [];
    });
  }

  getHistory(): number[] {
    return this.history;
  }

  getLastPage(): number {
    this.history.pop();
    const latestPage = this.history.at(-1);

    if (latestPage) {
      return latestPage;
    } else {
      return 0; // never will happen
    }
  }
}

export default HistoryPages.getInstance();
